const seoMetaData = {
  home: {
    title: 'CloudKodeForm - Expert Cloud & App Development Services',
    description:
      'CloudKodeForm offers custom cloud solutions, mobile app development, and digital transformation services to help your business scale and innovate.',
    keywords: "cloud solutions, AI development, full-stack development, digital transformation, app development company, cloud consulting"
  },
  about: {
    title: 'About CloudKodeForm - Your Trusted Tech Partner',
    description:
      'Learn more about CloudKodeForm Technologies, our mission, our team, and our experience in delivering successful digital solutions globally.',
    keywords: "about CloudKodeForm, software company profile, tech team, IT services company"
  },
  contact: {
    title: 'Contact CloudKodeForm - Get in Touch with Us',
    description:
      'Reach out to CloudKodeForm for cloud services, app development, or to discuss your next digital project. We’re here to help.',
    keywords: "contact CloudKodeForm, tech support, IT services contact, app development inquiries"
  },
  services: {
    title: 'Our Services - Cloud, Mobile App, Web Development',
    description:
      'Explore our wide range of services including cloud development, mobile apps, websites, ERP integration, and AI-powered solutions.',
    keywords: "IT services, mobile app services, cloud platform, ERP solutions, AI services"
  },
  career: {
    title: 'Careers at CloudKodeForm - Join Our Team',
    description:
      'Looking to build your future in tech? Explore current job openings and join the growing team at CloudKodeForm Technologies.',
    keywords: "IT jobs, software careers, tech hiring, CloudKodeForm careers"
  },
  caseStudies: {
    title: 'Case Studies - Our Work at CloudKodeForm',
    description:
      'Discover real-world success stories from clients who partnered with CloudKodeForm to transform their digital vision into reality.',
    keywords: "IT case studies, client success, software implementation stories"
  },
  portfolio: {
    title: 'Portfolio - See Our Projects and Designs',
    description:
      'Take a look at our featured portfolio showcasing web designs, app interfaces, and cloud-based systems built by CloudKodeForm.',
    keywords: "project showcase, web portfolio, mobile app designs, software examples"
  },
  privacyPolicy: {
    title: 'Privacy Policy - CloudKodeForm',
    description:
      'Understand how CloudKodeForm handles your data and what privacy practices we follow when you visit or interact with our website.',
    keywords: "data privacy, IT policy, cloudkodeform privacy policy"
  },
  recruitmentPolicy: {
    title: 'Recruitment Privacy Policy - CloudKodeForm',
    description:
      'Learn how CloudKodeForm collects and protects applicant data during the hiring process. Your privacy is important to us.',
    keywords: "recruitment policy, candidate data privacy, hiring policy"
  },
  cookies: {
    title: 'Cookie Policy - CloudKodeForm',
    description:
      'This page explains how we use cookies to enhance your browsing experience and improve our website performance.',
    keywords: "cookie policy, browser cookies, user data tracking"
  },
  feedback: {
    title: 'Share Your Feedback - CloudKodeForm',
    description:
      'We value your feedback. Tell us how we’re doing and how we can improve our services.',
    keywords: "customer feedback, service reviews, cloudkodeform feedback"
  },
  security: {
    title: 'Security Policy - CloudKodeForm',
    description:
      'Learn about the security measures CloudKodeForm implements to protect your data and ensure safe interactions with our services.',
    keywords: "data security, cyber protection, IT safety practices"
  },
  cookieSettings: {
    title: 'Cookie Settings - CloudKodeForm',
    description:
      'Manage your cookie preferences on the CloudKodeForm website. Choose which types of cookies you allow for a personalized experience.',
    keywords: "cookie settings, privacy controls, website data management"
  },
  mobileApp: {
    title: "Mobile App Development Services | CloudKodeForm",
    description:
      "Build powerful Android & iOS apps with CloudKodeForm. We create scalable, secure, and user-friendly mobile apps tailored to your business needs.",
    keywords: "mobile app development, iOS app developers, Android app solutions, cross-platform apps"
  },
  cloudServices: {
    title: "Cloud Solutions & Services | CloudKodeForm",
    description:
      "Elevate your business with our secure and scalable cloud services. From migration to cloud-native development, CloudKodeForm has you covered.",
    keywords: "cloud migration, cloud-native apps, cloud architecture, cloud consulting"
  },
  ai: {
    title: "AI Solutions & Services | CloudKodeForm",
    description:
      "Leverage artificial intelligence to transform your business. We offer custom AI models, automation, and smart insights for data-driven growth.",
    keywords: "AI services, machine learning models, data insights, intelligent automation"
  },
  migrationServices: {
    title: "Application & Cloud Migration Services | CloudKodeForm",
    description:
      "Seamlessly migrate your apps, data, or infrastructure with our expert migration services. Zero downtime, complete security.",
    keywords: "app migration, cloud migration, legacy system migration, zero downtime"
  },
  webDevelopment: {
    title: "Web Development Services | CloudKodeForm",
    description:
      "Create stunning, responsive websites with CloudKodeForm. We specialize in custom web development, e-commerce, and CMS solutions.",
    keywords: "web development, responsive design, e-commerce websites, CMS integration"
  },
  devOps: {
    title: "DevOps Solutions & Automation | CloudKodeForm",
    description:
      "Accelerate software delivery with our DevOps solutions. CI/CD pipelines, infrastructure as code, and automation for streamlined deployments.",
    keywords: "DevOps services, CI/CD integration, infrastructure automation, cloud DevOps"
  },
  micro: {
    title: "Microservices Development & Architecture | CloudKodeForm",
    description:
      "Break monoliths into microservices with our scalable architecture solutions. Improve agility, resilience, and performance in your applications.",
    keywords: "microservices architecture, API development, containerized apps, scalable systems"
  },
  reacts: {
    title: 'React Development Services | CloudKodeForm',
    description:
      'Build dynamic and scalable web applications with CloudKodeForm’s expert React.js development services. We deliver intuitive user experiences with React.',
    keywords: "React development, React.js developers, frontend JavaScript, SPA development"
  },
  python: {
    title: 'Python Development Solutions | CloudKodeForm',
    description:
      'CloudKodeForm offers robust Python development for automation, data science, and backend systems. Trusted Python developers for scalable solutions.',
    keywords: "Python development, backend development, data science apps, automation scripts"
  },
  laravel: {
    title: 'Laravel Web Development Company | CloudKodeForm',
    description:
      'We specialize in Laravel development to build fast, secure, and scalable web applications. Partner with CloudKodeForm for custom Laravel solutions.',
    keywords: "Laravel development, PHP web apps, Laravel developers, custom Laravel solutions"
  },
  nodejs: {
    title: 'Node.js Application Development | CloudKodeForm',
    description:
      'Leverage non-blocking, real-time Node.js apps for your business. CloudKodeForm provides high-performance backend solutions with Node.js.',
    keywords: "Node.js development, real-time apps, JavaScript backend, scalable APIs"
  },
  aiml: {
    title: 'AI & ML Development Services | CloudKodeForm',
    description:
      'Transform your data into insights with AI and Machine Learning. CloudKodeForm builds intelligent systems to drive automation and growth.',
    keywords: "AI ML services, machine learning models, predictive analytics, AI consulting"
  },
  mlops: {
    title: 'MLOps Consulting & Implementation | CloudKodeForm',
    description:
      'Ensure smooth AI/ML deployment with our MLOps services. We manage, monitor, and scale your models effectively using best DevOps practices.',
    keywords: "MLOps services, ML model deployment, AI pipeline, machine learning DevOps"
  },
  spring: {
    title: 'Spring Framework Development | CloudKodeForm',
    description:
      'CloudKodeForm builds secure, robust, and enterprise-grade applications using Spring Boot and the full Spring framework ecosystem.',
    keywords: "Spring Boot development, Java enterprise apps, Spring Framework solutions"
  },
};

export default seoMetaData;
